import { Button } from '@/components/ui/Button';
import { ErrorState } from '@/components/ui/ErrorState';

import { State } from '../State';

export function ErrorStateExamples() {
  return (
    <>
      <State
        title="With a retry"
        note="The retry here reloads nothing; it is the control itself."
      >
        <ErrorState
          title="The campaigns could not be loaded."
          onRetry={() => undefined}
          testId="gallery-error-state-retry"
        />
      </State>

      <State
        title="A way onward, no retry"
        note="For a record that does not exist: asking again would give the same answer."
      >
        <ErrorState
          title="This campaign was not found. It may have been removed, or the address may be wrong."
          action={
            <Button
              variant="secondary"
              size="sm"
              data-testid="gallery-error-state-back-button"
            >
              Back to campaigns
            </Button>
          }
          testId="gallery-error-state-not-found"
        />
      </State>

      <State title="Both" note="Try again first, then the way onward.">
        <ErrorState
          title="This campaign could not be loaded."
          onRetry={() => undefined}
          action={
            <Button
              variant="secondary"
              size="sm"
              data-testid="gallery-error-state-both-back-button"
            >
              Back to campaigns
            </Button>
          }
          testId="gallery-error-state-both"
        />
      </State>

      <State title="With the server's reason" note="A second line under the sentence.">
        <ErrorState
          title="The campaigns could not be loaded."
          description="The server answered: too many requests. Wait a moment before trying again."
          onRetry={() => undefined}
          testId="gallery-error-state-with-description"
        />
      </State>
    </>
  );
}
